import React, {useState} from 'react';
import {uploadFile} from "../../services/API";
import Header from "../../components/navigation/Header";
import ImageContent from "../course/ImageContent";
import {useError} from "../../hooks/useError";

function Upload(){

    const[file, setFile] = useState(null);
    const[alt, setAlt]   = useState("");
    const[description, setDescription]   = useState("");
    const [uploadResponse, setUploadResponse] = useState(null);
    const {setErrorMessage} = useError();
    const fileTypes = ["video/mp4", "video/quicktime", "image/png", "image/jpeg", "image/svg+xml"];


    function onFileSelect(event){

        if(fileTypes.includes(event.target.files[0].type)){
            setFile(event.target.files[0]);
        }else{
            alert("Filformatet støttes ikke");
            event.target.files[0] = null;
        }
    }


    function handleUpload(){

        if(file != null){
            uploadFile(file, alt, description, setErrorMessage).then(response => setUploadResponse(response)).catch(error => console.log(error));
        }
    }

    return (
        <div>
            <Header></Header>
            <div className={"container pt-5"}>
                <div className={"row"}>
                    <div className={"col"}>
                        <h1>Last opp media</h1>

                        <div className="d-flex flex-column mt-5">
                            <form encType="multipart/form-data" className="my-4">
                                <input className="form-control mb-2" type="text" placeholder="Bildetekst / alternativ tekst for universell utforming" value={alt} onChange={(e) => setAlt(e.target.value)}/>
                                <input className="form-control mb-2" type="text" placeholder="Kort kommentar av fil for internt bruk hvis nødvendig" value={description} onChange={(e) => setDescription(e.target.value)}/>
                                <br/>

                                <label>File :</label>
                                <input  type="file" id="myFile2" name="filename" accept={fileTypes.join(",")} onChange={(e) => onFileSelect(e)}/>

                                <input type="button" value="Last opp fil" onClick={(e) => handleUpload() }/>
                            </form>
                        </div>

                        {
                            uploadResponse != null ?
                                <div>
                                    {
                                        uploadResponse.success ? <div className={"rounded bg-success p-3"}><p>Media lastet opp</p></div> : <div className={"rounded bg-danger p-3"}><p>{uploadResponse.exception}</p></div>
                                    }
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>ID</td>
                                                <td>{uploadResponse.id}</td>
                                            </tr>
                                            <tr>
                                                <td>filename</td>
                                                <td>{uploadResponse.fileName}</td>
                                            </tr>
                                            <tr>
                                                <td>Link</td>
                                                <td>
                                                    <a href={uploadResponse.link}>
                                                        {uploadResponse.link}
                                                    </a>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                                :
                                null
                        }
                    </div>
                    <div className={"col"}>
                        <ImageContent hash={"PLACEHOLDER"} alt={"Last opp ett bilde eller en video"}/>
                    </div>

                </div>

            </div>
        </div>




);


}



export default Upload;